import React, { useEffect, useState } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import itemCompanyCatalogService from '../../service/itemCompanyCatalog.service';

const ItemCompanyCatalogReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection, autocompleteOptions }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'itemCode', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    itemCompanyCatalogService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'itemCode',
      headerName: 'Cikkszám',
      type: 'string',
    },
    {
      field: 'companyId',
      headerName: 'Cég',
      type: 'singleSelect',
      renderCell: (params) => {
        const option = autocompleteOptions?.company?.find((opt) => opt.value === params.value);
        return <span>{option?.label ?? ''}</span>;
      },
      valueOptions: autocompleteOptions?.company ?? [],
    },
    {
      field: 'itemCodeInBp',
      headerName: 'ÜP cikkszám',
      type: 'string',
    },
    {
      field: 'itemNameInBp',
      headerName: 'ÜP cikk név',
      type: 'string',
    },
    {
      field: 'active',
      headerName: 'Aktív',
      type: 'boolean',
    },
    {
      field: 'note',
      headerName: 'Megjegyzés',
      type: 'string',
      sortable: false,
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.ItemCompanyCatalog}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
      getRowId={(row) => row.id ?? `${row.itemCode ?? ''}_${row.companyId ?? ''}`}
    />
  );
};

export default ItemCompanyCatalogReports;
